<template>
  <v-navigation-drawer
    v-if="isAuthenticated"
    v-model="isExpandLeftMenu"
    app
    dark
    class="elevation-1"
    :src="require('@/assets/left_nav_back.jpg')"
  >
    <v-list rounded>
      <template v-for="({icon, text, action, can}, i) in items">
        <v-list-item v-if="$can(can[0], can[1])" :key="i" link :to="action" color="primary">
          <v-list-item-icon>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          action: "/",
          can: ["read", "all"]
        },
        {
          icon: "mdi-account-group",
          text: "Zákazníci",
          action: "/customers",
          can: ["read", "all"]
        },
        {
          icon: "mdi-account-tie",
          text: "Zamestnanci",
          action: "/employees",
          can: ["read", "all"]
        },
        {
          icon: "mdi-book-open-outline",
          text: "Objednávky",
          action: "/orders",
          can: ["read", "all"]
        },
        {
          icon: "mdi-database",
          text: "Skladové karty",
          action: "/storage-cards",
          can: ["read", "all"]
        },
        {
          icon: "mdi-cogs",
          text: "Výrobné príkazy",
          action: "/manufacturing-commands",
          can: ["read", "all"]
        },
        {
          icon: "mdi-lan-pending",
          text: "Pracoviská",
          action: "/workplaces",
          can: ["read", "workplaces"]
        },
        {
          icon: "mdi-cogs",
          text: "Konfigurácia",
          action: "/configurations",
          can: ["read", "all"]
        }
      ]
    };
  },
  computed: {
    isExpandLeftMenu: {
      get() {
        return this.$store.getters.isExpandLeftMenu;
      },
      set(value) {
        this.$store.commit("expandLeftMenu", value);
      }
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>
